var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnfinishedGame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 136 136",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard2",
    x: 0,
    y: 0,
    width: 135.583,
    height: 135.583,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.643,86.489c0.488,0.634 1.25,0.996 2.05,0.973c0.8,-0.022 1.541,-0.426 1.993,-1.086c3.069,-4.483 9.052,-13.221 12.572,-18.361c0.532,-0.776 0.583,-1.784 0.132,-2.61c-0.45,-0.825 -1.325,-1.328 -2.265,-1.302c-6.87,0.194 -19.286,0.542 -26.156,0.736c-0.94,0.026 -1.786,0.577 -2.189,1.427c-0.403,0.849 -0.295,1.853 0.279,2.598c3.803,4.934 10.267,13.322 13.584,17.625Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.212,67.791c-0,-22.176 17.977,-40.154 40.154,-40.154c22.161,0 40.154,17.993 40.154,40.154c-0,22.177 -17.978,40.154 -40.154,40.154l-0,-10.038c16.632,-0 30.115,-13.483 30.115,-30.116c0,-16.621 -13.494,-30.115 -30.115,-30.115c-16.633,-0 -30.116,13.483 -30.116,30.115l-10.038,0Z",
    style: {
      fill: "currentColor"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfinishedGame);
export default __webpack_public_path__ + "static/media/unfinishedGame.e23184f2.svg";
export { ForwardRef as ReactComponent };